module.exports = ".tl-timemarker.tl-timemarker-active .tl-timemarker-content-container{\r\n    background-color:#cfa64b;\r\n    color: #cfa64b;\r\n    z-index:9;\r\n    border-color:#cfa64b;\r\n    -webkit-box-shadow:1px 1px 3px #cfa64b;\r\n    box-shadow:1px 1px 3px #cfa64b;\r\n}\r\n.tl-timemarker.tl-timemarker-active .tl-timemarker-content-container .tl-timemarker-content h2.tl-headline {\r\n    /* color: #DF5B11 !important; */\r\n    font-weight: bold;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/timeline/timeline.component.css
// module id = ./src/app/components/ui/timeline/timeline.component.css
// module chunks = main